import React from 'react';
import renderHTML from 'react-render-html';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import {
  stripStartingAndEndingPTags,
} from '../../../ssm-homepage/ssm-homepage.actions';
import './plan-item.css';

const PlanItem = (props) => {
  const {
    item: {
      title,
      summary,
      subTitle,
      benefits,
    },
    customClass,
  } = props;

  const benefitsList = () => {
    const list = benefits.map((benefit, index) => (
      <div key={`plan-benefits-list-item-${index + 1}`} className="plan-benefits-list-item">
        <p><SvgIcon name="icon-system-ui-tick" className="svg" /></p>
        <p className="heading16 account-label-text">
          {benefit}
        </p>
      </div>
    ));
    return list;
  };

  return (
    <div className={`plan-item tl-animate ${customClass}`}>
      <div className="heading24 plan-heading">{title}</div>
      <div className="sub-title">
        <SvgIcon name="icon-network-speed" className="network-speed" />
        <div className="heading16 plan-sub-heading">{subTitle}</div>
      </div>
      <div className="text-regular plan-description">{renderHTML(stripStartingAndEndingPTags(summary))}</div>
      <hr className="divider" />
      <div className="plan-benefits-list">
        {benefitsList()}
      </div>
    </div>
  );
};

export default PlanItem;
